import { render } from "./TabBody.vue?vue&type=template&id=663c3392&scoped=true"
import script from "./TabBody.vue?vue&type=script&lang=js"
export * from "./TabBody.vue?vue&type=script&lang=js"

import "./TabBody.vue?vue&type=style&index=0&id=663c3392&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-663c3392"]])

export default __exports__